const k = (a) => window.btoa(a).replace(/\+/g, "-").replace(/\//g, "_"), o = ({ router: a, options: r, serverCAS: t, jwtServerUrl: e }) => {
  if (localStorage.clear(), !(r != null && r.loginRoute)) {
    if (!e || !t)
      throw new Error("You must provide the JWT Server URL and the CAS Server URL.");
    let n = `${e}/redirect/${k(window.location.href)}`;
    window.location.replace(
      `${t}/cas/login?service=${encodeURIComponent(n)}`
    );
    return;
  }
  if (!(r != null && r.loginRouteIsInternal)) {
    window.location.replace(r == null ? void 0 : r.loginRoute);
    return;
  }
  if (!a)
    throw new Error("If you want to use an internal route, you must provide the router instance.");
  a.push(r == null ? void 0 : r.loginRoute).then(() => {
  });
}, I = (a) => {
  if (!a)
    throw new Error("You must provide the CAS Server URL.");
  localStorage.clear(), window.location.replace(`${a}/cas/logout`);
}, m = (a) => a ? JSON.parse(window.atob(a.split(".")[1])).exp < Math.trunc(Date.now() / 1e3) : !0, S = async (a, r) => {
  var t;
  if (!a)
    throw new Error("You must provide the axios instance.");
  if (!r)
    throw new Error("You must provide the JWT Server URL.");
  try {
    const e = await a.post(
      `${r}/token/refresh/`,
      { refresh: localStorage.getItem("JWT__refresh__token") }
    );
    localStorage.setItem("JWT__access__token", e.data.access);
  } catch (e) {
    throw new Error("Vue cas authentication plugin error : " + ((t = e.response) == null ? void 0 : t.data) || "refresh error");
  }
}, g = ({ jwtServerUrl: a, serverCAS: r, router: t, axios: e, options: n }, _ = !0) => async (l) => {
  var h;
  return (h = l.url) != null && h.match(/\/token\//) || (localStorage.getItem("JWT__access__token") !== null ? (m(localStorage.getItem("JWT__access__token")) && (localStorage.getItem("JWT__refresh__token") !== null ? m(localStorage.getItem("JWT__refresh__token")) ? await o({ router: t, options: n, jwtServerUrl: a, serverCAS: r }) : await S(e, a) : await o({ router: t, options: n, jwtServerUrl: a, serverCAS: r })), l.headers.Authorization = `Bearer ${localStorage.getItem("JWT__access__token")}`) : _ && await o({ router: t, options: n, jwtServerUrl: a, serverCAS: r })), l;
}, R = () => ({
  axiosRequestInterceptor: g,
  login: o
}), T = {
  /**
   * Uses axios and the VusJS router to use CAS for login and logout :
   * - Login: redirects to the CAS login URL with the JWT server for the service.
   * - Logout: empties the local storage and redirect to the CAS logout URL.
   * - URL protected: checks if the URL has the meta "unistraCasAuthentication". If it's the meta use the login method.
   *
   * Documentation: https://git.unistra.fr/vue/cas-authentication
   *
   * @param {App} app - Vue instance.
   * @param {Router} router - VueJS Router instance; Init the router with the logout URL, cf. documentation.
   * @param {Object} axios - Axios instance; Init this instance and add this to vue initialization.
   * @param {function} axios.post
   * @param {Object} options - Object containing the additional options.
   * @param {Boolean} options.appIsAllAuth - Option to indicate if the app is fully protected.
   * @param {String} options.authCasLogoutUrl - Name URL for logout. Init this route in the router.
   * @param {Boolean} options.hasFreeAPI - If the app has a free API, the axios request interceptor will not be added.
   * @param {String} options.jwtServerUrl - URL of JWT server
   * @param {String} options.serverCAS - URL of CAS server
   * @param {object} options.tokenErrorRoutes - error code as key, corresponding redirection url as value
   */
  install(a, { router: r, axios: t, options: e }) {
    if (!r)
      throw new Error("You must install Vue-Router and pass an instance as a parameter of the CAS call.");
    if (!t)
      throw new Error("You must install Axios and Vue-Axios and pass an instance as a parameter of the CAS call.");
    const n = (e == null ? void 0 : e.jwtServerUrl) ?? "https://jwtserver-pprd.app.unistra.fr/api", _ = (e == null ? void 0 : e.serverCAS) ?? "https://cas.unistra.fr", l = {
      ...(e == null ? void 0 : e.tokenErrorRoutes) ?? {},
      default: "vue_cas_token_error"
    }, h = Object.values(l);
    a.provide("casLogin", o), r.getRoutes().every((c) => c.name !== "vue_cas_token_error") && r.addRoute({
      path: "/token/_error",
      name: "VueCasTokenError",
      component: a.component("VueCasTokenError", {
        template: "<div>no token retrieved, authentication failed</div>"
      })
    }), r.beforeEach(
      async (c, v, u) => {
        var i, w;
        if (c.name === (e == null ? void 0 : e.authCasLogoutUrl)) {
          I(_), u(!1);
          return;
        }
        if (h.includes(c.name)) {
          u();
          return;
        }
        if (c.query.service && c.query.ticket)
          try {
            const s = await t.post(`${n}/token/`, c.query);
            localStorage.setItem("JWT__access__token", s.data.access), localStorage.setItem("JWT__refresh__token", s.data.refresh), window.location.href = window.location.origin + window.location.pathname, u(!1);
            return;
          } catch (s) {
            let d = l.default;
            if ((i = s.response) != null && i.status) {
              const f = (w = s.response) == null ? void 0 : w.status;
              f && l[`${f}`] && (d = l[`${f}`]);
            }
            u({ name: d });
            return;
          }
        if ((e != null && e.appIsAllAuth || c.matched.some((s) => s.meta.unistraCasAuthentication)) && (!localStorage.getItem("JWT__refresh__token") || !localStorage.getItem("JWT__access__token"))) {
          await o({ router: r, options: e, jwtServerUrl: n, serverCAS: _ }), u(!1);
          return;
        }
        u();
      }
    ), e != null && e.hasFreeAPI || t.interceptors.request.use(
      g(
        { axios: t, router: r, options: e, jwtServerUrl: n, serverCAS: _ },
        !1
      ),
      (c) => Promise.reject(c)
    );
  }
};
export {
  T as CasAuthentication,
  R as useCasAuthentication
};
